import autosize from 'autosize';

// グローバルスコープに公開（既存コードとの互換性のため）
window.autosize = autosize;

document.addEventListener('DOMContentLoaded', () => {
  autosize(document.querySelectorAll('textarea'));
});
